import { FC } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { FormMasiveUploadBooking } from '../Forms/FormMasiveUploadBooking'
import { FormMasiveUploadResumedBooking } from '../Forms/FormMasiveUploadResumedBooking'
import { TableBookingsWrapper } from '../Tables/TableBookings'
import { useHoteleria } from '../../../../../../hooks/useHoteleria'
import { FormMasiveUploadCheckinPrinting } from '../Forms/FormMasiveUploadCheckinPrinting'
import { FormCancelReservations } from '../Forms/FormCancelReservations'

const HeaderBookingPanel: FC = () => {
  const { isAllowed } = useHoteleria()
  return (
    <>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Reservas</Tab>
            {isAllowed('MASIVO') && <Tab className={'sdx_sub_tab_panel_option'}>Carga Masiva</Tab>}
            {isAllowed('MASIVO_RESUMIDA') && (
              <Tab className={'sdx_sub_tab_panel_option'}>Carga Masiva Resumida</Tab>
            )}
            {isAllowed('MASIVO_CHECKIN_IMPRESION') && (
              <Tab className={'sdx_sub_tab_panel_option'}>Carga Masiva Checkin Impresión</Tab>
            )}
            <Tab className={'sdx_sub_tab_panel_option'}>Cancelar Reservas</Tab>
          </TabList>
          <TabPanel>
            <TableBookingsWrapper />
          </TabPanel>
          {isAllowed('MASIVO') && (
            <TabPanel>
              <FormMasiveUploadBooking />
            </TabPanel>
          )}
          {isAllowed('MASIVO_RESUMIDA') && (
            <TabPanel>
              <FormMasiveUploadResumedBooking />
            </TabPanel>
          )}
          {isAllowed('MASIVO_CHECKIN_IMPRESION') && (
            <TabPanel>
              <FormMasiveUploadCheckinPrinting />
            </TabPanel>
          )}
          <TabPanel>
            <FormCancelReservations />
          </TabPanel>
        </Tabs>
      </div>
    </>
  )
}

export { HeaderBookingPanel }
